import { useLanguage, pick } from "@/lib/lang";

/**
 * WhatsAppButton — direkter Klick öffnet WhatsApp sofort.
 * Kein Modal, kein Backend-Roundtrip, kein Popup-Blocker-Problem.
 * Nummer ist im href sichtbar und vorbefüllt mit einer freundlichen Default-Nachricht.
 */

const PHONE = "4917672870776";
const DEFAULT_MESSAGE = {
  de: "Hallo Patrice, ich habe eine Frage zu Sichtbar Gut Bewertet.",
  en: "Hi Patrice, I have a question about Sichtbar Gut Bewertet.",
};

const COPY = {
  cta: { de: "Oder via WhatsApp", en: "Or via WhatsApp" },
};

export const WhatsAppButton = ({ className = "" }) => {
  const { lang } = useLanguage();
  const text = encodeURIComponent(pick(DEFAULT_MESSAGE, lang));
  const href = `https://wa.me/${PHONE}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={`${pick(COPY.cta, lang)} – +49 176 72870776`}
      title="+49 176 72870776"
      className={`group inline-flex items-center gap-3 px-5 py-3 border border-atmosphere/45 hover:border-signal/70 transition-all duration-500 font-mono text-[0.66rem] tracking-[0.32em] uppercase ${className}`}
      style={{ background: "transparent" }}
    >
      <span
        aria-hidden
        className="inline-flex items-center justify-center w-5 h-5 rounded-full"
        style={{ background: "#FF7100" }}
      >
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.992-1.4A9.953 9.953 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2Zm5.07 14.27c-.214.604-1.243 1.157-1.74 1.218-.444.054-1.007.077-1.626-.102-.375-.111-.857-.27-1.475-.532-2.595-1.108-4.289-3.71-4.418-3.881-.13-.171-1.054-1.4-1.054-2.671 0-1.27.665-1.894.901-2.153.236-.258.514-.323.686-.323.171 0 .343 0 .493.008.158.007.37-.06.578.44.214.515.728 1.78.793 1.91.064.13.107.279.021.45-.086.171-.13.278-.257.428-.129.149-.27.334-.386.448-.129.128-.263.267-.113.524.15.257.668 1.102 1.434 1.785.984.879 1.815 1.151 2.072 1.28.257.13.408.108.557-.064.15-.172.643-.751.815-1.009.171-.258.343-.215.578-.129.235.086 1.492.703 1.748.83.257.129.428.193.493.301.064.107.064.622-.15 1.225Z" fill="#FAF7F2"/>
        </svg>
      </span>
      <span className="group-hover:text-signal transition-colors">{pick(COPY.cta, lang)}</span>
      <span aria-hidden style={{ color: "#FF7100" }}>↗</span>
    </a>
  );
};

export default WhatsAppButton;
